<template>
  <page-view title>
    <div slot="headerContent">
      <search-robot @changeRobotId="onChangeRobotId"></search-robot>
    </div>
    <exception-page type="norobot" v-if="!currentRobotId" />
    <a-card :bordered="false" v-if="currentRobotId">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="查询条件">
                <a-select v-model="queryParam.search_condition" placeholder="请选择查询条件" allowClear>
                  <a-select-option value="1">微信ID</a-select-option>
                  <a-select-option value="2">微信昵称</a-select-option>
                  <a-select-option value="3">微信号</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="查询内容">
                <a-input v-model="queryParam.keywords" placeholder="请输入查询内容" />
              </a-form-item>
            </a-col>
            <template v-if="advanced"> </template>
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
                <a-button style="margin-left: 8px" @click="() => (queryParam = {})">重置</a-button>
                <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a> -->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operator">
        <a-popconfirm placement="topLeft" @confirm="handleRefresh">
          <template slot="title">
            <p>您确认要刷新好友数据吗？</p>
          </template>
          <a-button type="primary" :disabled="FansRefreshStatus ? true : false">刷新好友数据</a-button>
        </a-popconfirm>
        <a-popconfirm placement="topLeft" @confirm="handleAddGroupAll">
          <template slot="title">
            <p>您确认要加入群发列表吗？</p>
          </template>
          <a-button type="primary" >全部加入群发列表</a-button>

        </a-popconfirm>
        <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay">
            <a-menu-item key="5" @click="handleAddGroup">加入群发列表</a-menu-item>
          </a-menu>
          <a-button style="margin-left: 8px">
            批量操作
            <a-icon type="down" />
          </a-button>
        </a-dropdown>

        <div style="width: 200px; margin-top: -3px">
          <a-progress
            v-if="FansRefreshStatus"
            :percent="FansRefreshStatus['progress']"
            size="small"
            :format="(percent) => parseInt(percent) + '%'"
          />
        </div>
      </div>
      <s-table
        :alert="options.alert"
        :rowSelection="options.rowSelection"
        ref="table"
        rowKey="id"
        :columns="columns"
        :data="loadData"

        :pagination="{ showQuickJumper: true, onChange: handlePagechange }">
        <!--  -->
        <!--  -->
        <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
        <span slot="avatar" slot-scope="text">
          <a-avatar shape="square" size="small" icon="user" :src="text" />
        </span>
        <span slot="nickname" slot-scope="text">
          <span v-line-clamp="1">{{ text }}</span>
        </span>
        <span slot="wx_id" slot-scope="record">
          <span v-line-clamp="1">{{ record.wx_id }}</span>
        </span>
        <span slot="wx_number" slot-scope="record">
          <span v-line-clamp="1">{{ record.wx_number ? record.wx_number : '无' }}</span>
        </span>
        <span slot="qdlastdt" slot-scope="text">
          <span>{{ text ? text : '无签到记录' }}</span>
        </span>
        <span slot="order_date" slot-scope="text">
          <span>{{ text ? text : '无下单记录' }}</span>
        </span>
        <template slot="sex" slot-scope="record">
          <span v-if="record.sex == '1'">
            <a-tag color="blue">男</a-tag>
          </span>
          <span v-else-if="record.sex == '2'">
            <a-tag color="pink">女</a-tag>
          </span>
          <span v-else>
            <a-tag>未知</a-tag>
          </span>
        </template>
        <template slot="region" slot-scope="record">
          <span v-if="record.address">{{ record.province }} {{ record.address }}</span>
          <span v-else>未知</span>
        </template>
        <span slot="avatar" slot-scope="text">
          <a-avatar shape="square" size="small" icon="user" :src="text" />
        </span>
        <template slot="action" slot-scope="text, record">
          <div class="editable-row-operations">
            <span>
              <a-dropdown>
                <a-menu slot="overlay">
                  <!-- <a-menu-item @click="handleSendMsgByWxid(record.wwid)">发送微信消息</a-menu-item> -->
                  <a-menu-item @click="handleAddBlacklist(record)">加入黑名单</a-menu-item>
                </a-menu>
                <a>
                  操作
                  <a-icon type="down" />
                </a>
              </a-dropdown>
            </span>
          </div>
        </template>
      </s-table>
    </a-card>
    <detail-drawer ref="detaildrawer"></detail-drawer>
    <send-msg-modal ref="sendMsgModal"></send-msg-modal>
    <add-blacklist-modal ref="addBlacklistModal" @ok="$refs.table.refresh()"></add-blacklist-modal>
  </page-view>
</template>

<script>
import { STable, ExceptionPage } from '@/components'
import SearchRobot from '@/views/components/SearchRobot'
import FansApi from '@/api/fans'
import { PageView } from '@/layouts'
import { mapActions, mapGetters } from 'vuex'

import DetailDrawer from '@/views/fans/detail/drawer'
import SendMsgModal from './modules/SendMsgModal'
import AddBlacklistModal from './modules/AddBlacklistModal'
import DemoVideoAlert from '@/views/components/DemoVideoAlert'
import { message } from 'ant-design-vue'
import GrouppushApi from '@/api/grouppush'
export default {
  name: 'FansWxlist',
  components: {
    PageView,
    STable,
    SearchRobot,
    ExceptionPage,
    DetailDrawer,
    SendMsgModal,
    AddBlacklistModal,
    DemoVideoAlert
  },
  data() {
    return {
      currentRobotId: null,
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '系统ID',
          width: 80,
          dataIndex: 'id',
          sorter: true
        },
        {
          title: '头像',
          dataIndex: 'avatar',
          width: 80,
          scopedSlots: { customRender: 'avatar' }
        },
        {
          title: '微信昵称',
          dataIndex: 'nickname',
          width: 200,
          scopedSlots: { customRender: 'nickname' }
        },
        {
          title: '微信ID',
          width: 200,
          scopedSlots: { customRender: 'wx_id' }
        },
        {
          title: '微信号',
          width: 200,
          scopedSlots: { customRender: 'wx_number' }
        },
        {
          title: '操作',
          width: '80px',
          scopedSlots: { customRender: 'action' }
        }
      ],

      selectedRowKeys: [],
      selectedRows: [],
      // 分组数据
      groupInfoData: {},
      // custom table alert & rowSelection
      options: {
        alert: {
          show: true,
          clear: () => {
            this.selectedRowKeys = []
          }
        },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        return FansApi.getWxUserList(
          Object.assign(parameter, this.queryParam, {
            sub_id: this.currentRobotId
          })
        )
      }
    }
  },
  computed: {
    currentRobotGroupInfoData() {
      const currentRobotId = this.currentRobotId
      const groupInfoData = this.groupInfoData
      return groupInfoData[currentRobotId]
    },
    FansRefreshStatus() {
      const robotid = this.currentRobotId
      const fun = this.getRobotFansRefreshStatusById()
      const data = fun(robotid)
      if (data && data['conduct']) {
        return data
      } else {
        return false
      }
    }
  },
  methods: {
    ...mapActions(['WEBSOCKER_ACTIONS_SENDROBOTMSG', 'demoSetVideo']),
    ...mapGetters(['getRobotFansRefreshStatusById']),
    handlePagechange(p, s) {
      this.$refs.table.clearSelected()
    },
    handleAddGroupAll () {
      console.log('全部加入群发列表');
      const hide = message.loading('请稍后...')
      // GrouppushApi.tongXunLuToTask({
      GrouppushApi.addUserToTask({
        sub_id: this.currentRobotId,
        push_type: 2,
        member_type: 2
      }).then(res => {
        if (res.code === 1) {
          message.success('操作成功')
        } else {
          message.error(res.msg)
        }
      }).finally(() => hide())
    },
    handleAddGroup () {
      const uids = this.selectedRows.map(item => {
        return item.id
      })
      const hide = message.loading('请稍后...')
      // GrouppushApi.tongXunLuToTask({
      GrouppushApi.addUserToTask({
        sub_id: this.currentRobotId,
        push_type: 1,
        member_ids: uids,
        member_type: 2
      }).then(res => {
        if (res.code === 1) {
          message.success('操作成功')
        } else {
          message.error(res.msg)
        }
      }).finally(() => hide())
    },
    onChangeRobotId(id) {
      this.currentRobotId = id
      if (this.$refs.table) {
        this.$refs.table.refresh(true)
      }
      // 获取分组
      FansApi.getGroupList({ sub_id: id }).then((res) => {
        this.groupInfoData[id] = res.data
      })
    },
    // 会员详情
    handleFansDetail(id) {
      this.$router.push({ path: `/fans/detail/${this.currentRobotId}/${id}` })
    },
    tableOption() {
      if (!this.optionAlertShow) {
        this.options = {
          alert: {
            show: true,
            clear: () => {
              this.selectedRowKeys = []
            }
          },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    handleDelete(id) {
      this.$refs.table.refresh()
    },
    handleChange(value, record, key) {
      record.editable_data[key] = value
    },
    handleSendMsg() {
      const wxids = this.selectedRows.map((item) => {
        let wwid = item.wwid
        wwid = wwid.replace(/-/g, 'p')
        wwid = wwid.replace(/\*/g, 'o')
        wwid = wwid.replace(/&/g, 'i')
        wwid = wwid.replace(/\^/g, 'u')
        wwid = window.atob(wwid)
        return wwid
      })
      this.$refs.sendMsgModal.show({ robotid: this.currentRobotId, wxids: wxids })
    },
    handleSendMsgByWxid(wwid) {
      wwid = wwid.replace(/-/g, 'p')
      wwid = wwid.replace(/\*/g, 'o')
      wwid = wwid.replace(/&/g, 'i')
      wwid = wwid.replace(/\^/g, 'u')
      this.$refs.sendMsgModal.show({ robotid: this.currentRobotId, wxids: [window.atob(wwid)] })
    },
    handleRefresh() {
      this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
        robotid: this.currentRobotId,
        type: 'refreshwxlist',
        data: {}
      }).then((result) => {
        this.$message.success('发送指令成功')
      })
    },
    handleAddBlacklist(data) {
      data.wxid = data.wx_id
      this.$refs.addBlacklistModal.show(this.currentRobotId, data)
    },
    handleRegister() {
      const wxids = this.selectedRows.map((item) => {
        return item.wx_id
      })
      this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
        robotid: this.currentRobotId,
        type: 'WxuserRegister',
        data: wxids
      }).then((result) => {
        this.$message.success('发送指令成功')
      })
    }
  }
}
</script>
<style lang="less" scoped>
.table-operator {
  display: flex;
  flex-direction: row;
  align-items: center;
}
/deep/ .page-header {
  .extra {
    display: none;
  }
  .headerContent {
    flex: 0 1 100% !important;
  }
}
</style>
